import { Modifier } from '@popperjs/core';

export const minWidth: Modifier<'minWidth', Record<string, never>> = {
  name: 'minWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn({ state }) {
    state.styles.popper.minWidth = `${state.rects.reference.width}px`;
  },
  effect({ state }) {
    const reference = state.elements.reference as HTMLElement;
    const popper = state.elements.popper as HTMLElement;
    popper.style.minWidth = `${reference.offsetWidth}px`;
    return () => {};
  }
};
